import Vue from 'vue';
import axios from 'axios';
import { Toast } from 'vant';
import Router from 'vue-router';
import store from '@/store/index';

Vue.use(Toast);

axios.defaults.timeout = 1000 * 20; // 超时设置
axios.defaults.baseURL = process.env.API_ROOT_MAIN; // api 根地址
axios.defaults.withCredentials = false; // 表示跨域请求时是否需要使用凭证, 默认false

// 解析地址栏参数方法
const qs = (search) => {
    if (typeof search !== 'string' || !search) return search;
    return search.split('&').reduce((res, cur) => {
        const arr = cur.split('=');
        return Object.assign({[arr[0]]: arr[1]}, res);
    }, {});
};

// request 拦截器
axios.interceptors.request.use((config) => {
    let token;
    let params = window.location.href.includes('?') && window.location.href.split('?')[1];
    let url = config.url;
    let token1 = store.state.token;
    let token2 = qs(params).token;
    token = token1 || token2;
    token && (config.headers.token = token); // 设置Token，适用于token加在headers场景
    config.url = url.includes('?') ? `${url}&token=${token}` : `${url}?token=${token}`; // 设置Token，适用于token加在url场景
    config.loading && store.commit('showLoading'); // 默认打开loading，可在实际请求中关闭
    return config;
}, (error) => {
    store.commit('hideLoading'); // 关闭loading
    return Promise.reject(error);
});

// response 拦截器
axios.interceptors.response.use((response) => {
    store.commit('hideLoading'); // 关闭loading
    if (response.status === 200) {
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
}, (error) => {
    store.commit('hideLoading'); // 关闭loading
    if (error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
        Toast.loading({
            message: '请求超时，请检查您的网络',
            duration: 2000
        });
        return Promise.reject(error.response);
    }
    if (error.response.status) {
        switch (error.response.status) {
        // 401: 未登录
        case 401:
            Router.replace({
                path: '/login',
                query: {
                    redirect: ''
                }
            });
            break;
        // 403 token过期
        case 403:
            Toast.loading({
                message: '登录过期，请重新登录',
                duration: 1000
            });
            // 清除token
            localStorage.removeItem('token');
            Router.replace({
                path: '/login',
                query: {
                    redirect: ''
                }
            });
            break;

        // 404 请求不存在
        case 404:
            Toast.loading({
                message: '网络请求不存在',
                duration: 1500
            });
            break;

        // 其他错误，直接抛出错误提示
        default:
            Toast.loading({
                message: error.response.data.message,
                duration: 1500
            });
        }
        return Promise.reject(error.response);
    }
});

// 封装get请求
export function Get (url, params, headers) {
    let _headers = headers || {};
    return new Promise((resolve, reject) => {
        axios.defaults.loading = !(_headers.loading === 0); // 可设置loading: 0关闭接口请求loading动效，默认开启
        axios.get(url, {params: params,
            headers: {
                'Content-Type': _headers['Content-Type'] || 'application/json;charset=UTF-8',
                ..._headers
            }
        }).then(res => {
            resolve(res.data);
        }).catch(error => {
            reject(error.data);
        });
    });
}

// 封装post请求
export function Post (url, params, headers) {
    let _headers = headers || {};
    return new Promise((resolve, reject) => {
        axios.defaults.loading = !(_headers.loading === 0); // 可设置loading: 0关闭接口请求loading动效，默认开启
        axios.post(url, params, {
            headers: {
                'Content-Type': _headers['Content-Type'] || 'application/json;charset=UTF-8', // headers对象参数传入自定义Content-Type
                ..._headers
            }
        })
            .then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.data);
            });
    });
}

// 封装put请求
export function Put (url, params, headers) {
    let _headers = headers || {};
    return new Promise((resolve, reject) => {
        axios.defaults.loading = !(_headers.loading === 0); // 可设置loading: 0关闭接口请求loading动效，默认开启
        axios.put(url, params, {
            headers: {
                'Content-Type': _headers['Content-Type'] || 'application/json;charset=UTF-8' // headers对象参数传入自定义Content-Type
            }
        })
            .then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.data);
            });
    });
}



// WEBPACK FOOTER //
// ./src/config/axios.js